import { render } from "./snsView.vue?vue&type=template&id=136a3d36&scoped=true"
import script from "./snsView.vue?vue&type=script&lang=js"
export * from "./snsView.vue?vue&type=script&lang=js"

import "./snsView.vue?vue&type=style&index=0&id=136a3d36&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136a3d36"]])

export default __exports__